/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_G_ShipInputs */

const tr_landing_integrations_g_ship = /** @type {(inputs: Landing_Integrations_G_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kargo`)
};

const en_landing_integrations_g_ship = /** @type {(inputs: Landing_Integrations_G_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping`)
};

const de_landing_integrations_g_ship = /** @type {(inputs: Landing_Integrations_G_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versand`)
};

const ru_landing_integrations_g_ship = /** @type {(inputs: Landing_Integrations_G_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка`)
};

/**
* | output |
* | --- |
* | "Shipping" |
*
* @param {Landing_Integrations_G_ShipInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_g_ship = /** @type {((inputs?: Landing_Integrations_G_ShipInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_G_ShipInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_g_ship(inputs)
	if (locale === "de") return de_landing_integrations_g_ship(inputs)
	if (locale === "ru") return ru_landing_integrations_g_ship(inputs)
	return tr_landing_integrations_g_ship(inputs)
});